import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Estado vacío. Se usa cuando una pantalla aún no tiene datos (o, por ahora, cuando la
 * pantalla todavía no está construida — ver `PlaceholderPage`).
 */
export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-card border border-dashed border-line-strong bg-surface/60 px-6 py-12 text-center',
        className,
      )}
    >
      {icon ? (
        <span className="flex size-12 items-center justify-center rounded-pill bg-brand-50 text-brand-600">
          {icon}
        </span>
      ) : null}

      <div className="space-y-1">
        <h3 className="text-card-title font-semibold text-ink">{title}</h3>
        {description ? (
          <p className="mx-auto max-w-md text-caption text-ink-muted">{description}</p>
        ) : null}
      </div>

      {action}
    </div>
  );
}
